import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PlStageActivityContainerComponent } from './containers/pl-stage-activity-container/pl-stage-activity-container.component';
import { PipelinedetailsContainerComponent } from "./containers/pipelinedetails-container/pipelinedetails-container.component";

const routes: Routes = [
	{path: 'pipelinedetails', component: PipelinedetailsContainerComponent},
	{ path: 'pipelinetemplate', component: PlStageActivityContainerComponent },
];

@NgModule({
	imports: [ RouterModule.forChild(routes) ],
exports: [ RouterModule ]
})
export class PipelineRoutingModule {}
